export default __webpack_public_path__ + "img/carousel-left.2075e535.svg";